// Displays modal for user to edit file name before auto uploading

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import EmaDestinationModal from './EmaDestinationModal';

import AutoUpload from '../../components/modal/AutoUpload';
import AutoUploadLegacy from '../../components/modal/AutoUpload.legacy';
import { triggerAutoUpload, triggerAutoUploadAndTaskCreation, refreshCurrentRecords } from '../../actions/records';
import {
  getDocumentCategories, getEmaTaskProviders, getKareoTaskProviders, getTaskTemplatesByQuery, getEmaPatients, getTebraPatients, getMarketingRepresentatives,
} from '../../actions/userProfile';
import { hasFeatureInLocalStorage } from '../../global/featureFlags';

class AutoUploadDialog extends Component {
  render() {
    // Short-lived rollout flag: render the redesigned Send-to-Chart modal when the
    // org has it enabled, otherwise the pre-redesign (legacy) one. Sync flag read
    // keeps the choice render-safe.
    //
    // Hard-gated to EMA: the redesigned patient-match flow is only fully correct for
    // EMA today — the Tebra/Kareo bound-chart upload-and-task path isn't wired yet
    // (see the chart-identity note in CreateNewChart.fileToExistingChart). Non-EMA
    // orgs keep the legacy modal even with the flag on, so the broken path is
    // unreachable in prod.
    const redesignEnabled = hasFeatureInLocalStorage('redesigned_ema_api_chart_modals')
      && localStorage.getItem('m8_auto_upload_emr') === 'EMA';
    const SendToChartModal = redesignEnabled ? AutoUpload : AutoUploadLegacy;
    // eslint-disable-next-line react/jsx-props-no-spreading
    if (redesignEnabled) return <EmaDestinationModal {...this.props} ModalComponent={SendToChartModal} />;
    return (
      <div>
        <SendToChartModal
          {...this.props}
        />
      </div>
    );
  }
}

AutoUploadDialog.defaultProps = {
  fileName: '',
};

AutoUploadDialog.propTypes = {
  fileName: PropTypes.string,
  triggerAutoUpload: PropTypes.func.isRequired,
  triggerAutoUploadAndTaskCreation: PropTypes.func.isRequired,
};

export default connect(state => ({
  sendToken: state.auth.data.sendToken,
  fileName: state.auth.data.fileName,
}), {
  triggerAutoUpload,
  getDocumentCategories,
  getEmaTaskProviders,
  getKareoTaskProviders,
  triggerAutoUploadAndTaskCreation,
  getTaskTemplatesByQuery,
  getEmaPatients,
  getTebraPatients,
  getMarketingRepresentatives,
  refreshCurrentRecords,
})(AutoUploadDialog);
